import { createSvgComponent } from "../../icon/createSvgComponent";
import ChatbubbleQuestionFill from "@core/__generated__/icon/figma/chatbubble-question-fill.svg";
export default createSvgComponent(ChatbubbleQuestionFill);